import * as React from "react";

import DemoPage from "../components/demo/demo";
import Layout from "../components/layout/layout";
import Seo from "../components/seo";
import { useTranslation } from 'react-i18next';

const Demo = () => {
  const {t} = useTranslation();
  return (
    <>
      <Seo
        title={t('demo')}
        description="Découvrez les solutions Mereos"
      />
      <Layout>
        <DemoPage />
      </Layout>
    </>
  );
};

export default Demo;
